import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ru from './locales/ru.json';
import uz from './locales/uz.json';
import en from './locales/en.json';

Vue.use(VueI18n);

const STORAGE_KEY = 'app-locale';
const SUPPORTED = ['ru', 'uz', 'en'];

function detectInitial() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED.includes(stored)) return stored;
  } catch (e) { /* ignore */ }
  return 'ru';
}

const i18n = new VueI18n({
  locale: detectInitial(),
  fallbackLocale: 'ru',
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  messages: { ru, uz, en },
});

export function setLocale(locale) {
  if (!SUPPORTED.includes(locale)) return;
  i18n.locale = locale;
  try { localStorage.setItem(STORAGE_KEY, locale); } catch (e) { /* ignore */ }
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', locale);
  }
}

if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', i18n.locale);
}

export const SUPPORTED_LOCALES = SUPPORTED;
export default i18n;
